<!-- =========================================================================================
  File Name: ResetAdminPasswordSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Change sadasdPassword</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <vx-input-group>
        <template slot="append">
          <div class="append-text cursor-pointer" style="color:#B0AFB7;background-color:white;border:1px solid rgba(0, 0, 0, 0.2); border-left:none">
            <span @click="showPassword = !showPassword">
                    <feather-icon v-if="showPassword" icon="EyeOffIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
                    <feather-icon v-else icon="EyeIcon"  class="flex-inline mt-2" svgClasses="h-5 w-5" />
              </span>
          </div>
        </template>
        <vs-input 
          ref="password"
          v-model="dataPassword" 
          icon="icon icon-lock"
          icon-pack="feather"
          icon-no-border
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:20'"
          v-bind:type="[showPassword ? 'text' : 'password']" 
          name="password"
          placeholder="Password"
          class="w-full no-right-border"
        />
      </vx-input-group>

        <vs-input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:20'"
          name="password"
          label-placeholder="New Password"
          placeholder="New Password"
          v-model="dataPassword"
          class="w-full mt-6"/>
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>

        <vs-input
          type="password"
          v-validate="'min:6|max:20|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm_password"
          label-placeholder="New Confirm Password"
          placeholder="New Confirm Password"
          v-model="dataConfPassword"
          class="w-full mt-6"/>
        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {UPDATE_ADMIN_USER_PASSWORD} from '@/graphql'

export default {
  props: {
    isResetPasswordSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }


  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      ActiveUserID: '',
      dataPassword: '',
      dataConfPassword: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      showPassword:false
    }
  },
  watch: {
    isResetPasswordSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id} = JSON.parse(JSON.stringify(this.data))
        this.ActiveUserID = id
        this.dataPassword = ''
        this.dataConfPassword = ''
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isResetPasswordSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },

    isFormValid () {
      return !this.errors.any() && (this.dataPassword === this.dataConfPassword)
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataPassword = ''
      this.dataConfPassword = ''
    },
    submitData () {


      if (this.ActiveUserID !== null && this.ActiveUserID >= 0) {
        this.$apollo
          .mutate({
            mutation: UPDATE_ADMIN_USER_PASSWORD,
            variables: {
              id: this.ActiveUserID,
              password: this.dataPassword
            }
          }).then(response => {
            if (response.data.updateAdminUserPassword.status == 'SUCCESS') {
              this.$vs.notify({
                title: 'Password',
                text: 'Password Updated Sucessfully',
                color: 'success',
                position: 'top-right'
              })
              this.$emit('closeSidebar')
              this.initValues()
            } else if (response.data.updateAdminUserPassword.status == 'NOT_MATCH') {
              this.$vs.notify({
                title: 'Old Password',
                text: 'Not Matched!',
                color: 'danger',
                position: 'top-right'
              })
            }
          })
      } else {
        this.$vs.notify({
          title: 'Invalid Data',
          text: 'Invalid input data!',
          color: 'danger',
          position: 'top-right'
        })
      }

      this.$validator.reset()

    }
  },
  created () {

    console.log(this.data)
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
